import { postUserVisit } from "components/app/App.slice";
import secureLocalStorage from "react-secure-storage";
import { store } from "redux/store";
import { LOGOUT_LOGIN_URL } from "./URLConstants";
import { commonApiCallParam } from "./UserAnalyticsUtils";

export const clearStorages = () => {
  localStorage.clear();
  secureLocalStorage.clear();
};

export const userLogout = async () => {
  console.log("Logging out due to idle timeout");
  const params = commonApiCallParam();
  const { dispatch } = store;
  params.visitedPage = "Logout";
  const res = await dispatch(postUserVisit(params));
  if (res?.payload?.status) {
    clearStorages();
    window.location.replace(LOGOUT_LOGIN_URL);
  }
};

export const handleUnauthorizedAccess = (showDialog = false) => {
  if (showDialog && localStorage.getItem("id_token")) {
    alert("Unable to authenticate at the moment. Please try login later.");
  }
  clearStorages();
  localStorage.setItem("url", window.location.pathname + window.location.search);
  window.location.replace(LOGOUT_LOGIN_URL);
};
